export var RdsCdcCheckScope;
(function (RdsCdcCheckScope) {
    RdsCdcCheckScope["RDS_CDC_CHECK_SCOPE_FULL"] = "FULL";
    RdsCdcCheckScope["RDS_CDC_CHECK_SCOPE_PARAMETERS_AND_SLOTS"] = "PARAMETERS_AND_SLOTS";
})(RdsCdcCheckScope || (RdsCdcCheckScope = {}));
